import React, { useEffect, useState } from "react";
import { getMatchesCard } from "../services/ScheduleService";

function Schedule() {
    const [matches, setMatches] = useState([]);
    const [activeFilter, setActiveFilter] = useState("Today");

    useEffect(() => {
        const fetchData = () => {
            getMatchesCard("upcoming").then((data) => {
                if (data && data.matches) {
                    const now = new Date();
                    const futureMatches = data.matches.filter(m => new Date(m.matchStartTime) > now);
                    setMatches(futureMatches);
                }
            });
        };

        fetchData();
        const interval = setInterval(fetchData, 30000);
        return () => clearInterval(interval);
    }, []);

    const formatTime = (startTime) => {
        if (!startTime) return "--:--";
        const date = new Date(startTime);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const filterMatches = () => {
        const now = new Date();
        const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        const tomorrowEnd = new Date(todayEnd);
        tomorrowEnd.setDate(tomorrowEnd.getDate() + 1);
        const weekEnd = new Date(todayEnd);
        weekEnd.setDate(weekEnd.getDate() + 7);

        if (activeFilter === "Today") {
            return matches.filter(m => new Date(m.matchStartTime) <= todayEnd);
        } else if (activeFilter === "Tomorrow") {
            return matches.filter(m => {
                const matchDate = new Date(m.matchStartTime);
                return matchDate > todayEnd && matchDate <= tomorrowEnd;
            });
        } else if (activeFilter === "This Week") {
            return matches.filter(m => new Date(m.matchStartTime) <= weekEnd);
        }
        return matches;
    };

    const getTeamName = (match, index) => {
        if (index === 0) return match.team1Name || "TBD";
        return match.team2Name || "TBD";
    };

    return (
        <div id="section-schedule" className="spanel active">
            <div className="main-wrap" style={{ padding: "18px 0" }}>
                <div className="fbar">
                    <button className={`fbtn ${activeFilter === "Today" ? "active" : ""}`} onClick={() => setActiveFilter("Today")}>Today</button>
                    <button className={`fbtn ${activeFilter === "Tomorrow" ? "active" : ""}`} onClick={() => setActiveFilter("Tomorrow")}>Tomorrow</button>
                    <button className={`fbtn ${activeFilter === "This Week" ? "active" : ""}`} onClick={() => setActiveFilter("This Week")}>This Week</button>
                </div>
                <div className="sh">Upcoming Virtual IPL Matches</div>
                {filterMatches().length === 0 && <p style={{ color: "var(--text2)" }}>No upcoming matches found.</p>}
                {filterMatches().map((match, index) => (
                    <div className="sched-card" key={match.matchId}>
                        <div className="sched-time-blk">
                            <div className="st-label">{index === 0 ? "Next" : "Today"}</div>
                            <div className="st-time">{formatTime(match.matchStartTime)}</div>
                            <div className="st-date">Today</div>
                        </div>
                        <div className="sched-main">
                            <div className="sched-teams">
                                {getTeamName(match, 0)}
                                <span style={{ color: "var(--text3)", fontSize: "11px" }}>vs</span>
                                {getTeamName(match, 1)}
                            </div>
                            <div className="sched-venue">
                                Virtual IPL · {match.matchId}
                            </div>
                        </div>
                        <div className="sched-right">
                            <div className="fmt-chip">VIRTUAL</div>
                            <div className="sched-odds-prev">1X2: <span>—</span> / <span>—</span> / <span>—</span></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Schedule;